import { useMutation } from 'react-query';
import { knsApi } from '../../api';

const useDelete = () => {
  const mutation = useMutation((id: number): any => {
    return knsApi.delete(id);
  });
  return mutation;
};

export default useDelete;
